import { networkContactFilter, dateFilter, networkContactSourceFilter } from '@/utils/filters';
export default {
    name: 'GridMobile',
    data() {
        return {
            notAvaliableMessage: 'Não disponível'
        };
    },
    props: {
        row: {
            type: Object,
            default: {}
        },
        contactsGrid: {
            type: Object,
            default: {}
        }
    },
    methods: {
        networkContactFilter,
        dateFilter,
        networkContactSourceFilter,
        toggleRowVisibility(row) {
            this.$set(row, 'visible', !row.visible);
            this.$forceUpdate();
        }
    }
};
